import React from "react";
import { toast } from "react-toastify";
import {
  bindModalClosed,
  getBinderPDF,
  bindExternalResponse,
  getBinderStatus,
  resetBinderPdf,
  setautoreminder,
} from "../store/components";
import { addTransaction } from "../store/transactions";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { readyTheCards } from "../store/helperfuncs";
import {
  PaymentMethodList,
  emailBodyBindProspect,
  emailBodyBindProspectText,
} from "../helper/constants";
import { getBinderViewRows } from "../store/mybinder";
import { NumericFormat } from "react-number-format";
import { getRowDetailsFromProspectId } from "../store/myquotes";
import Spinner from "react-bootstrap/Spinner";
import {
  getInsuerEmailv2,
  getResponseDetail,
  getProspectid,
  getProespectInformation,
  getCRS,
  udpatepolicyJustBinded,
  updateBindTypeInsurer,
  updateBindTypeCalled,
  updateBindType,
  getCovers,
  getResponseBindType,
} from "../store/quotes";
import { getBrokerInformation } from "../store/broker";
import { getInsurerOptionsList } from "../store/insurers";
import { getIsBpSuccess, updateBmsInfo, acturisBmsBind, updateProspectStatus } from "../store/qf";
import {
  getPolicyStatusData,
  getStatusApi,
  createPolicyApi,
} from "../store/policyStatus";
import {
  getCoverIdOfPrice,
  premium,
  insurerFees,
  brokerFees,
  premiumAndFees,
  commissionRate,
} from "../store/businesslogic/hardwiredlogic";
import { PossibleApiStatusValues } from "../store/helperfuncs";
import ReactLoading from "react-loading";
import Select from "react-select";
import InputGroup from "react-bootstrap/InputGroup";
import { Button, Col, Row } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import moment from "moment";
import ActionButton from "../general/ActionButton";
import PdfSettingsModal from "../components/PdfSettingsModal";
import Modal from "react-bootstrap/Modal";
import { generateInvoicePdf } from "./CustomPayment/Invoice";
import externalTranslations from '../utils/translations'
const BindModal = (props) => {
  const translations = {
    en: {
      modals: {
        modalA: {
          mainHeader: "Bind Instruction​",
          header: "Congratulations on the bind!",
          paragraph1:
            "This quote was originally generated by the insurer and is therefore bindable, so you can simply complete the information in this form and send to the insurer and they can get everything issued.​​",
          paragraph2:
            "Doing this through Quotey will enable you to create a binder, issue certificates and remove this prospect from your prospect list.​",
          button: "Create Bind Instruction​",
          items: [
            {
              number: 1,
              text: "Update the information on this form so that everything is accurate including effective date, expiry date, payment method, premiums and fees. Don’t forget to apply any taxes.​",
            },
            {
              number: 2,
              text: "Click on the button to create a bind instruction for the insurer. This will create a PDF that you will need to email to the insurer.​",
            },
            {
              number: 3,
              text: "Send the Bind Instruction PDF to the insurer by email.​",
            },
            {
              number: 4,
              text: "You can collect payment, issue Certificates (as permitted by your insurer).​",
            },
            {
              number: 5,
              text: "The insurer will issue documents in due course.​​",
            },
          ],
        },
        modalB: {
          mainHeader: "Firm-up Quote Request​​",
          header: "Firm-up Request",
          paragraph1:
            `The quote you are reviewing is an indication. This means that it needs to be confirmed by the underwriter prior to binding.
            

            You can request that the underwriter reviews this indication and provides bindable terms through this process.`,
          paragraph2:
            "Please note, no policy or coverage is bound until confirmed by the insurer.",
          button: "Create Firm-up Request​",
          items: [
            {
              number: 1,
              text: "Update the information on this form where relevant. For example, if you want to specify an expiry date then add this information into the form.",
            },
            {
              number: 2,
              text: "Click on the button to send a request to the insurer to review the quote and provide bindable terms. This will automatically create and send an email to the insurer with all the quote requirements. You will also get a copy.​",
            },
            {
              number: 3,
              text: "The insurer will return with confirmation of the indication or alternative bindable terms.​​",
            },
            {
              number: 4,
              text: "Once you have received bindable terms, you can go  back into this quote, click on Bind, confirm any changes to the original indication and request a bind as per the bindable quote process.​",
            },
    
          ],
        },
        modalC: {
          button: "Create Bind Instruction​​",
          mainHeader: "Bind Instruction​",
          header: "Congratulations on the bind!",
          paragraph1:
            "This quote is bindable, so you can simply complete the information in this form and send to the insurer and they can get everything issued.",
          paragraph2:
            "Please remember any other binding commitments or constraints that you may have with the insurer. This does not grant binding authority that would otherwise not exist, for example, when there are pending floods, fires or other natural catastrophes or where insurers have restricted or removed binding authority.",
          items: [
            {
              number: 1,
              text: "Update the information on this form so that everything is accurate including effective date, expiry date, payment method, premiums and fees. Don’t forget to apply any taxes.​​",
            },
            {
              number: 2,
              text: "Click on the button to bind. This will automatically email the insurer with a copy of the quote and all bind requirements. You will get a copy.​",
            },
            {
              number: 3,
              text: "You can collect payment, issue Certificates (as permitted by your insurer).​​",
            },
            {
              number: 4,
              text: "The insurer will issue documents in due course.​​​",
            },
          ],
        },
        modalD: {
          // Assuming modalD was missing; if not, add as needed
        },
        modalE: {
          button: "Bind Now​​",
          mainHeader: "Bind Instruction​",
          header: "Congratulations on the bind!",
          paragraph1:
            "This quote is instantly bindable. Please check the information on this page, and once you are happy, click 'Bind Now.'",
          paragraph2:
            "Please note, that this will instantly, and automatically bind the policy with the insurer and your brokerage will be responsible for the collection of premiums and payment to the insurer unless the insurer offers a direct bill payment method.",
          items: [
            {
              number: 1,
              text: "Update the information on this form so that everything is accurate including effective date, expiry date, payment method, premiums and fees. Don't forget to apply the taxes.",
            },
            {
              number: 2,
              text: "Ensure that you have made arrangements for payment with your client. [Remember: You can send a payment request through Quotey's Client Presentation options if you haven't already.]",
            },
            {
              number: 3,
              text: "Click on the 'Bind Now' button which will instantly connect with the insurer to bind the policy. You'll receive an on-screen notification to confirm.",
            },
            {
              number: 4,
              text: "This client will be findable in the “My Binders” section of Quotey, where you can create Certificates etc.",
            },
            {
              number: 5,
              text: "Documents will be instantly downloadable, and available by clicking on the “Go to Transactions and Documents” button on the Binder Information screen.",
            },
          ],
        },
        modalF: {
          button: "Click to bind in insurer's portal​",
          mainHeader: "Bind Instruction​",
          header: "Congratulations on the bind!",
          paragraph1:
            "This quote was originally generated by the insurer and is bindable in the insurer's portal. You'll be able to get this policy up and running in a matter of minutes!",
          paragraph2: "",
          subText1:
            "No policies or coverage is bound until confirmed by the insurer in their portal.",
          subText2:
            "Please note, we've built a link directly to the insurer's portal so you can get there by clicking the Bind button. In some cases, you will need to ensure that your user credentials for the insurer's portal are also up-to-date in Quotey. If this is not the case, please ask your Quotey admin to update. If necessary, you will also be able to go directly to the insurer's portal (through traditional means), find the quote and bind.",
          items: [
            {
              number: 1,
              text: "Update the information on this form so that everything is accurate including effective date, expiry date, payment method, premiums and fees. Don't forget to apply the taxes.",
            },
            {
              number: 2,
              text: "Click on the button to go directly to the insurer's portal* and finish the bind process. Don't worry - all the quote information will be there, ready for you to make any final adjustments and bind.",
            },
            {
              number: 3,
              text: "You can collect payment, issue Certificates (as permitted by your insurer).",
            },
            {
              number: 4,
              text: "Documents will be issued by the insurer.",
            },
          ],
        },
        modalG: {
          button: "Click to firm up and bind in insurer's portal​",
          mainHeader: "Bind Instruction​",
          header: "Congratulations on the bind!",
          paragraph1:
            "This quote was originally generated by the insurer but has been flagged for review or clarification of certain information so should be treated as an indication only at this stage.",
          paragraph2:
            "In order to firm-up and finalize the quote, you can click here and go through to the insurer's portal and complete any additional information about the risk.",
          subText1:
            "No policies or coverage is bound until confirmed by the insurer in their portal.",
          subText2:
            "Please note, we've built a link directly to the insurer's portal so you can get there by clicking the Bind button. In some cases, you will need to ensure that your user credentials for the insurer's portal are also up-to-date in Quotey. If this is not the case, please ask your Quotey admin to update. If necessary, you will also be able to go directly to the insurer's portal (through traditional means), find the quote and bind.",
          items: [
            {
              number: 1,
              text: "Update the information on this form so that everything is accurate including effective date, expiry date, payment method, premiums and fees. Don't forget to apply the taxes.",
            },
            {
              number: 2,
              text: "Click on the button to go directly to the insurer's portal*, firm up the quote and finish the bind process. Don't worry - all the quote information will be there, ready for you to confirm any additional information, finalize the quote (where applicable) and bind.",
            },
            {
              number: 3,
              text: "You can collect payment, issue Certificates (as permitted by your insurer).",
            },
            {
              number: 4,
              text: "Documents will be issued by the insurer.",
            },
          ],
        },
      },
      form: {
        generalBindInformation: "General Bind Information",
        financials: "Financials",
        insurerLabel: "Insurer *",
        bindNumberLabel: "Bind Number",
        quoteReferenceLabel: "Quote Reference *",
        effectiveDateLabel: "Effective Date *",
        expiryDateLabel: "Expiry Date *",
        paymentMethodLabel: "Payment Method *",
        premiumLabel: "Premium *",
        insurerFeesLabel: "Insurer Fees *",
        brokerFeesLabel: "Broker Fees",
        premiumAndFeesLabel: "Premium & Fees *",
        taxRateApplicableLabel: "Tax rate applicable (%)",
        taxesPayableLabel: "Taxes payable",
        commissionRateLabel: "Commission rate (%)",
        commissionEarnedLabel: "Commission earned",
        selectPaymentMethodPlaceholder: "Select a payment method",
      },
      common: {
        hereIsTheProcess: "Here is the process:",
      },
    },
    fr: {
      // **New Translations for Modals**
      modals: {
        modalA: {
          mainHeader: "Instruction de Liaison​",
          header: "Félicitations pour la liaison!",
          paragraph1:
            "Ce devis a été généré à l'origine par l'assureur et est donc liant, vous pouvez donc simplement compléter les informations dans ce formulaire et l'envoyer à l'assureur pour qu'il puisse tout émettre.​​",
          paragraph2:
            "Faire cela via Quotey vous permettra de créer un accord de liaison, d'émettre des certificats et de retirer ce prospect de votre liste de prospects.​",
          button: "Créer une instruction de liaison​",
          items: [
            {
              number: 1,
              text: "Mettez à jour les informations sur ce formulaire afin que tout soit exact, y compris la date d'entrée en vigueur, la date d'expiration, le mode de paiement, les primes et les frais. N'oubliez pas d'appliquer les taxes.​",
            },
            {
              number: 2,
              text: "Cliquez sur le bouton pour créer une instruction de liaison pour l'assureur. Cela créera un PDF que vous devrez envoyer par email à l'assureur.​",
            },
            {
              number: 3,
              text: "Envoyez le PDF de l'instruction de liaison à l'assureur par email.​",
            },
            {
              number: 4,
              text: "Vous pouvez collecter le paiement, émettre des certificats (comme autorisé par votre assureur).​",
            },
            {
              number: 5,
              text: "L'assureur émettra les documents en temps voulu.​​",
            },
          ],
        },
        modalB: {
          mainHeader: "Demande de confirmation de devis",
          header: "Félicitations pour la souscription !",
          paragraph1: `L'indication que vous examinez doit être confirmée par le souscripteur avant la souscription.
        
        Vous pouvez demander au souscripteur de réexaminer cette indication et de fournir des conditions fermes via ce processus`,
          paragraph2: "Veuillez noter qu’aucune police ou couverture n’est souscrite tant que l’assureur ne l’a pas confirmée.",
          button: "Créer une demande de confirmation",
          items: [
            {
              number: 1,
              text: "Mettez à jour les informations de ce formulaire si nécessaire. Par exemple, si vous souhaitez spécifier une date d’expiration, ajoutez-la dans le formulaire."
            },
            {
              number: 2,
              text: "Cliquez sur le bouton pour envoyer une demande à l’assureur de réexaminer le devis et de fournir des conditions fermes. Un e‑mail contenant toutes les exigences du devis sera automatiquement généré et envoyé à l’assureur, et vous en recevrez une copie."
            },
            {
              number: 3,
              text: "L’assureur répondra en confirmant l’indication ou en proposant des conditions fermes alternatives."
            },
            {
              number: 4,
              text: "Une fois les conditions fermes reçues, retournez sur ce devis, cliquez sur « Souscrire », confirmez les éventuelles modifications apportées à l’indication initiale et demandez la souscription selon le processus des devis fermes."
            }
          ]
        }
        ,
        modalC: {
          button: "Créer une instruction de liaison​​",
          mainHeader: "Instruction de Liaison​",
          header: "Félicitations pour la liaison!",
          paragraph1:
            "Ce devis est liant, vous pouvez donc simplement compléter les informations dans ce formulaire et l'envoyer à l'assureur pour qu'il puisse tout émettre.",
          paragraph2:
            "Veuillez vous rappeler de tout autre engagement ou contrainte de liaison que vous pourriez avoir avec l'assureur. Cela ne confère pas l'autorité de liaison qui n'existerait pas autrement, par exemple, lorsqu'il y a des inondations, des incendies ou d'autres catastrophes naturelles en cours ou lorsque les assureurs ont restreint ou supprimé l'autorité de liaison.",
          items: [
            {
              number: 1,
              text: "Mettez à jour les informations sur ce formulaire afin que tout soit exact, y compris la date d'entrée en vigueur, la date d'expiration, le mode de paiement, les primes et les frais. N'oubliez pas d'appliquer les taxes.​​",
            },
            {
              number: 2,
              text: "Cliquez sur le bouton pour lier. Cela enverra automatiquement un email à l'assureur avec une copie du devis et toutes les exigences de liaison. Vous recevrez une copie.​",
            },
            {
              number: 3,
              text: "Vous pouvez collecter le paiement, émettre des certificats (comme autorisé par votre assureur).​​",
            },
            {
              number: 4,
              text: "L'assureur émettra les documents en temps voulu.​​​",
            },
          ],
        },
        modalE: {
          button: "Lier Maintenant​​",
          mainHeader: "Instruction de Liaison​",
          header: "Félicitations pour la liaison!",
          paragraph1:
            "Ce devis est immédiatement liant. Veuillez vérifier les informations sur cette page et, une fois satisfait, cliquez sur 'Lier Maintenant.'",
          paragraph2:
            "Veuillez noter que cela liera instantanément et automatiquement la police avec l'assureur, et votre courtier sera responsable de la collecte des primes et du paiement à l'assureur, sauf si l'assureur propose une méthode de paiement par facture directe.",
          items: [
            {
              number: 1,
              text: "Mettez à jour les informations sur ce formulaire afin que tout soit exact, y compris la date d'entrée en vigueur, la date d'expiration, le mode de paiement, les primes et les frais. N'oubliez pas d'appliquer les taxes.",
            },
            {
              number: 2,
              text: "Assurez-vous d'avoir pris des dispositions pour le paiement avec votre client. [Rappelez-vous : Vous pouvez envoyer une demande de paiement via les options de présentation client de Quotey si ce n'est pas déjà fait.]",
            },
            {
              number: 3,
              text: "Cliquez sur le bouton 'Lier Maintenant' qui connectera instantanément avec l'assureur pour lier la police. Vous recevrez une notification à l'écran pour confirmer.",
            },
            {
              number: 4,
              text: "Ce client sera visible dans la section « Mes Accord de Liaison » de Quotey, où vous pourrez créer des certificats, etc.",
            },
            {
              number: 5,
              text: "Les documents seront instantanément téléchargeables et disponibles en cliquant sur le bouton « Aller aux Transactions et Documents » sur l'écran d'information de l'accord de liaison.",
            },
          ],
        },
        modalF: {
          button: "Cliquez pour lier dans le portail de l'assureur​",
          mainHeader: "Instruction de Liaison​",
          header: "Félicitations pour la liaison!",
          paragraph1:
            "Ce devis a été généré à l'origine par l'assureur et est liant dans le portail de l'assureur. Vous pourrez mettre en place cette police en quelques minutes!",
          paragraph2: "",
          subText1:
            "Aucune police ou couverture n'est liée tant qu'elle n'est pas confirmée par l'assureur dans son portail.",
          subText2:
            "Veuillez noter que nous avons créé un lien directement vers le portail de l'assureur afin que vous puissiez y accéder en cliquant sur le bouton de liaison. Dans certains cas, vous devrez vous assurer que vos identifiants utilisateur pour le portail de l'assureur sont également à jour dans Quotey. Si ce n'est pas le cas, veuillez demander à votre administrateur Quotey de mettre à jour. Si nécessaire, vous pourrez également accéder directement au portail de l'assureur (par des moyens traditionnels), trouver le devis et le lier.",
          items: [
            {
              number: 1,
              text: "Mettez à jour les informations sur ce formulaire afin que tout soit exact, y compris la date d'entrée en vigueur, la date d'expiration, le mode de paiement, les primes et les frais. N'oubliez pas d'appliquer les taxes.",
            },
            {
              number: 2,
              text: "Cliquez sur le bouton pour accéder directement au portail de l'assureur* et terminer le processus de liaison. Ne vous inquiétez pas - toutes les informations du devis y seront, prêtes pour que vous puissiez effectuer les derniers ajustements et lier.",
            },
            {
              number: 3,
              text: "Vous pouvez collecter le paiement, émettre des certificats (comme autorisé par votre assureur).",
            },
            {
              number: 4,
              text: "Les documents seront émis par l'assureur.",
            },
          ],
        },
        modalG: {
          button:
            "Cliquez pour finaliser et lier dans le portail de l'assureur​",
          mainHeader: "Instruction de Liaison​",
          header: "Félicitations pour la liaison!",
          paragraph1:
            "Ce devis a été généré à l'origine par l'assureur mais a été marqué pour révision ou clarification de certaines informations, il doit donc être traité comme une indication uniquement à ce stade.",
          paragraph2:
            "Afin de finaliser et de clôturer le devis, vous pouvez cliquer ici et passer par le portail de l'assureur pour compléter toute information supplémentaire concernant le risque.",
          subText1:
            "Aucune police ou couverture n'est liée tant qu'elle n'est pas confirmée par l'assureur dans son portail.",
          subText2:
            "Veuillez noter que nous avons créé un lien directement vers le portail de l'assureur afin que vous puissiez y accéder en cliquant sur le bouton de liaison. Dans certains cas, vous devrez vous assurer que vos identifiants utilisateur pour le portail de l'assureur sont également à jour dans Quotey. Si ce n'est pas le cas, veuillez demander à votre administrateur Quotey de mettre à jour. Si nécessaire, vous pourrez également accéder directement au portail de l'assureur (par des moyens traditionnels), trouver le devis et le lier.",
          items: [
            {
              number: 1,
              text: "Mettez à jour les informations sur ce formulaire afin que tout soit exact, y compris la date d'entrée en vigueur, la date d'expiration, le mode de paiement, les primes et les frais. N'oubliez pas d'appliquer les taxes.",
            },
            {
              number: 2,
              text: "Cliquez sur le bouton pour accéder directement au portail de l'assureur*, finaliser le devis et terminer le processus de liaison. Ne vous inquiétez pas - toutes les informations du devis y seront, prêtes pour que vous puissiez confirmer toute information supplémentaire, finaliser le devis (le cas échéant) et lier.",
            },
            {
              number: 3,
              text: "Vous pouvez collecter le paiement, émettre des certificats (comme autorisé par votre assureur).",
            },
            {
              number: 4,
              text: "Les documents seront émis par l'assureur.",
            },
          ],
        },
      },
      form: {
        generalBindInformation: "Informations Générales de Liaison",
        financials: "Financiers",
        insurerLabel: "Assureur *",
        bindNumberLabel: "Numéro de Liaison",
        quoteReferenceLabel: "Référence de Devis *",
        effectiveDateLabel: "Date effective *",
        expiryDateLabel: "Date d'Expiration *",
        paymentMethodLabel: "Méthode de Paiement *",
        premiumLabel: "Prime *",
        insurerFeesLabel: "Frais de l'Assureur *",
        brokerFeesLabel: "Frais de Courtier",
        premiumAndFeesLabel: "Prime & Frais *",
        taxRateApplicableLabel: "Taux de taxe applicable (%)",
        taxesPayableLabel: "Taxes Payables",
        commissionRateLabel: "Taux de Commission (%)",
        commissionEarnedLabel: "Commission Gagnée",
        selectPaymentMethodPlaceholder: "Sélectionnez une méthode de paiement",
      },
      common: {
        hereIsTheProcess: "Voici le processus :",
      },
    },
  };

  const [timeStamp, setTimeStamp] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [failedBindModalOpen, setFailedBindModalOpen] = useState(false);
  const [description, setDescription] = useState({
    mainHeader: "Bind Instruction​",
    header: "Congratulations on the bind!",
    paragraph1:
      " This quote was originally generated by the insurer and is therefore bindable, so you can simply complete the information in this form and send to the insurer and they can get everything issued.​​",
    paragraph2:
      "Doing this through Quotey will enable you to create a binder, issue certificates and remove this prospect from your prospect list.​",
    button: "Create Bind Instruction​",
    items: [
      {
        number: 1,
        text: "Update the information on this form so that everything is accurate including effective date, expiry date, payment method, premiums and fees.  Don’t forget to apply any taxes.​",
      },
      {
        number: 2,
        text: "Click on the button to create a bind instruction for the insurer.  This will create a PDF that you will need to email to the insurer.​",
      },
      {
        number: 3,
        text: "Send the Bind Instruction PDF to the insurer by email.​",
      },
      {
        number: 4,
        text: "You can collect payment, issue Certificates (as permitted by your insurer).​",
      },
      {
        number: 5,
        text: "The insurer will issue documents in due course.​​",
      },
      // add more items here
    ],
  });
  const [pdfDownloading, setPdfDownloading] = useState(
    PossibleApiStatusValues.notstarted
  );

  const dispatch = useDispatch();
  const { insurerId, responseId, bindtype } = props;

  const insurer =
    useSelector(getResponseDetail(insurerId)) || props.insurerDetail;
  const insurerDetail = useSelector(getInsuerEmailv2(insurer.insurercode));
  const prospectid = useSelector(getProspectid);
  const prospectInformation = useSelector(getProespectInformation);
  const userInformation = useSelector(getBrokerInformation);
  const languagepreference = userInformation?.information?.languagepreference || "en";
  const policyStatus = useSelector(getPolicyStatusData);
  const rows = useSelector(getBinderViewRows);
  const prospectDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );
  const binderStatus = useSelector(getBinderStatus);
  const options = useSelector(getInsurerOptionsList);
  const [cardsObject, setCardsObject] = useState(readyTheCards(rows));
  const crs = useSelector(getCRS);
  const responseRe = useSelector(getResponseDetail(responseId));
  const responseBindType = useSelector(
    getResponseBindType({ responseid: insurerId })
  );
  const quoteRefID = insurer?.covers ? insurer?.covers[211] : [];
  const [bindTypeState, setBindType] = useState(
    bindtype || insurerDetail.bindtype
  );
  const [currentBindType, setCurrentBindType] = useState("")
  //console.log("prospectInformation", prospectInformation)
  useEffect(() => {
    if (responseBindType) {
      setBindType(responseBindType);
    }
  }, [responseBindType]);
  let covers = useSelector(getCovers(insurerId));
  let price = 0;
  let insurerFee = 0;
  let brokerFee = 0;
  let premiumAndFee = 0;
  let commissionRates = 0;
  let quoteReference = 0;
  if (covers !== null) {
    price = covers && parseFloat(covers[premium()]).toFixed(2);
    insurerFee = covers && parseInt(covers[insurerFees()]).toFixed(2);
    brokerFee = (covers && parseInt(covers[brokerFees()]).toFixed(2)) || 0;
    premiumAndFee = covers && parseInt(covers[premiumAndFees()]).toFixed(2);
    commissionRates = covers && parseInt(covers[commissionRate()]).toFixed(2);
    quoteReference = covers[211];
    if (
      price == "Refer" ||
      price == "Decline" ||
      price == "Pending" ||
      price == undefined ||
      price == null
    ) {
      price = 0;
    } else if (typeof price == "string") {
      if (price != "" && !isNaN(price)) {
        price = price;
      } else {
        price = 0;
      }
    }
  }
  const today = new Date();
  const yyyy = today.getFullYear();
  const yyyyy = yyyy + 1;
  let mm = today.getMonth() + 1;
  let dd = today.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const todayDate = yyyy + "-" + mm + "-" + dd;
  const nextYearDate = yyyyy + "-" + mm + "-" + dd;
  let numDays = insurerDetail?.otherinfo?.bindcutoffdays || 30;
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + numDays);
  const [maxDateFormatted] = maxDate.toISOString().split("T");
  useEffect(() => {
    setCardsObject(readyTheCards(rows));
  }, [rows]);
  const premiumVal = parseFloat(price);
  let insurerFeeVal = insurerFee;
  let brokerFeeVal = brokerFee ? brokerFee : 0;
  const [useEmail, setuseEmail] = useState();
  const [sendEmailDirect, setSendEmailDirect] = useState(false);
  const [bindData, setBindData] = useState({
    insurer: insurerDetail.name,
    bindernumber: 0,
    premium: premiumVal > 0 ? premiumVal : null || isNaN ? 0 : 0,
    quoteRef: quoteRefID ? quoteRefID : "-",
    insurerFees: insurerFeeVal > 0 ? insurerFeeVal : 0 || isNaN ? 0 : 0,
    brokerFees: isNaN(brokerFeeVal) ? 0 : brokerFeeVal,
    taxApplicable: 0,
    brokerComments: "",
    comissionRate:
      insurerDetail?.quotesby == "inhouse"
        ? covers && parseFloat(covers[commissionRate()] * 100)
        : 0 || insurerDetail?.quotesby == "manual"
        ? covers && parseFloat(covers[commissionRate()])
        : 0,
    paymentMethod: "Agency Bill",
    effectiveDate: todayDate,
    expiryDate: nextYearDate,
  });
  const [totalPremium, setTotalPremium] = useState(
    parseFloat(bindData.premium) +
      parseFloat(bindData.insurerFees) +
      parseFloat(bindData.brokerFees)
  );
  const [finalBindData, setFinalBindData] = useState({});
  const data = {
    insurer: bindData.insurer,
    bindernumber: bindData.bindernumber.toString(),
    premium: parseFloat(bindData.premium) || bindData.premium,
    quoteRef: bindData.quoteRef,
    insurerFees: parseFloat(bindData.insurerFees),
    brokerFees: parseFloat(bindData.brokerFees),
    taxApplicable: parseFloat(bindData.taxApplicable),
    brokerComments: bindData.brokerComments,
    comissionRate: parseFloat(bindData.comissionRate),
    paymentMethod: bindData.paymentMethod.value
      ? bindData.paymentMethod.value
      : "Agency Bill",
    effectiveDate: bindData.effectiveDate,
    expiryDate: bindData.expiryDate,
  };
  useEffect(() => {
    const currentTimestamp = Date.now();
    setTimeStamp(currentTimestamp);
    setBindData({ ...bindData, bindernumber: currentTimestamp });
  }, []);
  useEffect(() => {
    dispatch(getStatusApi());
  }, [dispatch]);

  function formatCurrency(number) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(number);
  }

  useEffect(() => {
    setTotalPremium(
      parseFloat(bindData.premium) +
        parseFloat(bindData.insurerFees) +
        parseFloat(bindData.brokerFees)
    );
  }, [bindData]);

  const textPayableValue =
    (totalPremium * parseFloat(bindData.taxApplicable).toFixed(2)) / 100;

  const commissionEarnedValue =
    (bindData.premium * parseFloat(bindData.comissionRate)) / 100;
  const inputStyle = {
    // marginLeft: "-25px",
    borderRadius: "5px",
    border: "0",
    width: "270px",
    lineHeight: "30px",
    marginBottom: "6px",
    paddingLeft: "20px",
    paddingRight: "5px",
  };
  const dollerSpan = {
    position: "absolute",
    color: "black",
    // left: "-15px",
    bottom: "30%",
    fontSize: "15px",
  };

  const history = useNavigate();

  const dateFormator = (initialDate) => {
    const dateData = initialDate.split("-");
    const returnDate = [dateData[1], dateData[2], dateData[0]].join("/");
    return returnDate;
  };

  const styles = {
    list: {
      listStyleType: "none",
      padding: 0,
      margin: 0,
    },
    listItem: {
      display: "flex",
      alignItems: "start",
      marginBottom: "25px",
    },
    listItemNumber: {
      maxWidth: "27px",
      maxHeight: "27px",
      lineHeight: "30px",
      backgroundColor: theme.COLORS.secondary_skyblue,
      color: "white",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "9px",
      fontSize: "1.1em",
      marginRight: "10px",
    },
  };

  /*

    Bind Code: 1
    name: Manual Bind request to insurer - Indication
    Bind Code: 2
    name: "Manual “Bind request” to insurer - Bindable"
    Bind Code: 3
    name: Manual Quote and Bind in insurer portal - Indication
    Bind Code: 4
    name: Manual Quote and Bind in insurer portal - Bindable
    Bind Code: 5
    name: Instant Bind with Insurer through APIs
    Bind Code: 6
    name: Bind and Issue on Quotey

   quotesby: [
  "manual",
  "inhouse",
  "external"
]


    */
  useEffect(() => {
    const getModalDescription = () => {
      if (insurerDetail.quotesby === "manual" && bindTypeState === "2") {
        return (
          translations[languagepreference]?.modals.modalA ||
          translations["en"].modals.modalA
        );
      } else if (
        insurerDetail.quotesby === "inhouse" ||
        insurerDetail.quotesby === "external"
      ) {
        switch (bindTypeState) {
          case "1":
            return (
              translations[languagepreference]?.modals.modalB ||
              translations["en"].modals.modalB
            );
          case "2":
            return (
              translations[languagepreference]?.modals.modalC ||
              translations["en"].modals.modalC
            );
          case "3":
            return (
              translations[languagepreference]?.modals.modalG ||
              translations["en"].modals.modalG
            );
          case "4":
            return (
              translations[languagepreference]?.modals.modalF ||
              translations["en"].modals.modalF
            );
          case "5":
          case "6":
            return (
              translations[languagepreference]?.modals.modalE ||
              translations["en"].modals.modalE
            );
          default:
            console.log("Description not set!!", insurerDetail.quotesby);
            return null;
        }
      } else {
        console.log("Description not set!!");
        return null;
      }
    };

    const modalDescription = getModalDescription();
    if (modalDescription) {
      setDescription(modalDescription);
    }
  }, [insurerDetail, bindTypeState, languagepreference]);

  useEffect(() => {
    console.log('policyStatus',policyStatus)
    // send email directly to insurer & broker or download eml file
    if (policyStatus && useEmail != undefined) {
      const statusId = policyStatus.policystatus.filter(
        (data) => data.name == "BINDER"
      )[0]._id;
      const startingDateData = dateFormator(bindData.effectiveDate);
      const endingDateData = dateFormator(bindData.expiryDate);
      const url = process.env.REACT_APP_BASICSERVICE + "/api/policies/create";
      const body = {
        prospectid: prospectid,
        startDate: startingDateData,
        expiryDate: endingDateData,
        statusid: statusId,
        usersid: userInformation.information._id,
        otherData: data,
        totalPremium: totalPremium,
        textPayableValue: textPayableValue,
        commissionEarnedValue: commissionEarnedValue,
        bindtype,
      };
      // const pdfLanguagePrefIsFrench =
      //   localStorage.getItem("pdfLanguagePrefIsFrench") === "true";
      // console.log("shoe me the trueth", pdfLanguagePrefIsFrench ? "fr" : "en");

      dispatch(createPolicyApi(body)).then(() => {
        //toast.success("Policy Created Successfully!");
        if (!["1", "3"].includes(bindTypeState)) {
          dispatch(udpatepolicyJustBinded({ value: true }));
        }
        if (["1", "3"].includes(bindTypeState)) {
          //bind type is 1,3 and we binded for 7, ask broker to create reminder
          setTimeout(() => {
            dispatch(
              setautoreminder({
                text: externalTranslations[languagepreference].autoReminderText ,
                title:  externalTranslations[languagepreference].autoReminderTitle ,
                prospectid,
                remindercategory: "cat-5",
              })
            );
            dispatch(updateBindTypeCalled({responseid: insurer._id, bindtype: "9" }))
            dispatch(updateProspectStatus({prospectid, statuscode:'under_review'}))
          }, 500);
        }
        //toast.success("Getting pdf...");
        let bindType = currentBindType
        if(currentBindType===""){
       bindType = insurer.source == "inhouse" ?  "bind1" : "bind2" ;
      }
         
        setPdfDownloading(PossibleApiStatusValues.loading);
        const showTOC = localStorage.getItem("showTOC") == "true";
        const showAnsweredOnly =
          localStorage.getItem("showAnsweredOnly") == "true";
        // Use user's profile language preference for PDF generation
        var binderPDFparms = {
          id: crs,
          bindType,
          include_toc: showTOC,
          show_empty_answers: showAnsweredOnly,
          pdf_language_selected: languagepreference || "en",
          bindData,
          bindId:bindTypeState
        };
        if (useEmail) {
          binderPDFparms = {
            id: crs,
            bindType,
            ...useEmail,
            include_toc: showTOC,
            show_empty_answers: showAnsweredOnly,
            pdf_language_selected: languagepreference || "en",
            bindData,
            bindId:bindTypeState
          };
        }
        if (["1", "3"].includes(bindTypeState)) {
          binderPDFparms.otherinfo = {
            ToStatus: "Quote Review Requested",
          };
        }
        if (["1", "3"].includes(bindTypeState)) {
          console.log("Calling Quote Review Requested!!")
          binderPDFparms.otherinfo = {
            ToStatus: "Quote Review Requested",
          };
        }
        dispatch(getBinderPDF(binderPDFparms))
          .then(() => {
            if (!sendEmailDirect) {
              toast.success(externalTranslations[languagepreference].fileDownloadNotification);
              setEmailModalOpen(true);
              setPdfDownloading(PossibleApiStatusValues.success);
              dispatch(updateProspectStatus({prospectid, statuscode:'sold'}))
              // props.handleBindModalClose();
            } else {
              setEmailModalOpen(true);
            }
          })
          .catch((e) => {
            toast.error("Something went wrong while getting Binder Pdf", {
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            dispatch(udpatepolicyJustBinded({ value: false }));
            setPdfDownloading(PossibleApiStatusValues.failed);
          });
      });
    }
  }, [useEmail]);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "270px",
      color: "black",
      borderRadius: "5px",
      inputStyle,
      paddingLeft: "20px",
      paddingRight: "5px",
    }),
    menu: (provided) => ({
      ...provided,
      width: "270px",
      color: "black", // Change the dropdown background color here
    }),
  };
  var readOnly = false;
  var isExternal = false;
  var _PaymentMethodList = PaymentMethodList;
  if (insurerDetail.otherinfo?.hidedirectbilling) {
    readOnly = true;
    _PaymentMethodList = [{ value: "Agency Bill", label: "Agency Bill" }];
  }

  var notDropDownButton = true;
  if (
    !isExternal &&
    insurer.insurercode !== "ApprovedCasualtyLegal" &&
    insurerDetail.quotesby == "manual" &&
    bindTypeState == "2" &&
    bindTypeState !== "4"
  ) {
    notDropDownButton = false;
  }

  const handlBindButton = () => {
    console.log("Bind Button called");
    console.log("Insurer Details:", insurer);
    console.log("Insurer ID:", insurerId);
    console.log("Bind Type State:", bindTypeState);
    console.log("Insurer Detail Quotes By:", insurerDetail.quotesby);
    console.log("Bind Data:", bindData); // Log the data being specific logic (seems correct)
    if(insurer.insurercode.toLowerCase().includes('soplex') && bindTypeState == "2"){
      console.log("SOPLEX BIND");
      dispatch(acturisBmsBind({responseid:insurerId, prospectid, bindData}));
      // Assuming acturisBmsBind handles modal closing or next steps
      return;
    }

    // Update BMS info (seems general)
    dispatch(updateBmsInfo({ action: 'bind_quote', postdata : { responseid:insurerId, prospectid, bindData }}));

    // Update bind type if it was an indication/referral type (1 or 3) -> setting to 9 (Requested)
    // This should probably happen *after* the action is successfully initiated
    // Moved this lower for clarity, will be triggered after setuseEmail or bindExternalResponse
    // if(["1","3"].includes(bindTypeState)){
    //   dispatch(updateBindTypeCalled({responseid: insurer._id, bindtype: "9" }))
    // }

    // --- Portal Bind Logic (Types 3 & 4) ---
    if (["3", "4"].includes(bindTypeState)) {
        console.log(`Portal Bind Initiated (Type ${bindTypeState})`);
        if (covers && covers[855]) { // Check if covers exists before accessing
            console.log("Redirecting to insurer portal:", covers[855]);
            window.location.href = covers[855];
            // Optionally update bind type to 9 if it was type 3?
             if(bindTypeState === "3"){
                dispatch(updateBindTypeCalled({responseid: insurer._id, bindtype: "9" }))
                dispatch(updateProspectStatus({prospectid, statuscode:'under_review'}))
             }
            return; // Stop execution after redirect
        }

        console.log("Dispatching bindExternalResponse for Portal Bind");
        const showTOC = localStorage.getItem("showTOC") == "true";
        const showAnsweredOnly = localStorage.getItem("showAnsweredOnly") == "true";
        // Use user's profile language preference for PDF generation

        dispatch(
            bindExternalResponse({
                responseid: insurerId,
                prospectid,
                include_toc: showTOC,
                show_empty_answers: showAnsweredOnly,
                 pdf_language_selected: languagepreference || "en", // Pass language
                otherinfo: {
                    effectiveDate: bindData.effectiveDate,
                    expiryDate: bindData.expiryDate,
                    // Add ToStatus if it was an indication type
                    ...(bindTypeState === "3" && { ToStatus: "Quote Review Requested" })
                },
            })
        );
         // Update bind type to 9 if it was type 3 after dispatch
        if(bindTypeState === "3"){
          dispatch(updateBindTypeCalled({responseid: insurer._id, bindtype: "9" }))
          dispatch(updateProspectStatus({prospectid, statuscode:'under_review'}))
        }
        props.handleBindModalClose(); // Close modal after dispatch

    // --- Instant Bind Logic (Types 5 & 6) ---
    } else if (
        insurer.insurercode !== "ApprovedCasualtyLegal" &&
        (insurerDetail.quotesby == "external" || insurerDetail.quotesby == "inhouse") &&
        !["1", "2", "3", "4"].includes(bindTypeState) && // Ensure it's not handled above
        ["5", "6"].includes(bindTypeState)
    ) {
        console.log(`Instant Bind Initiated (Type ${bindTypeState})`);
        const showTOC = localStorage.getItem("showTOC") == "true";
        const showAnsweredOnly = localStorage.getItem("showAnsweredOnly") == "true";
        // Use user's profile language preference for PDF generation

        dispatch(
            bindExternalResponse({
                responseid: insurerId,
                prospectid,
                include_toc: showTOC,
                show_empty_answers: showAnsweredOnly,
                pdf_language_selected: languagepreference || "en", // Pass language
                otherinfo: {
                    effectiveDate: bindData.effectiveDate,
                    expiryDate: bindData.expiryDate,
                },
            })
        );
        props.handleBindModalClose(); // Close modal after dispatch

    
    } else if (
        insurer.insurercode !== "ApprovedCasualtyLegal" &&
        (insurerDetail.quotesby == "external" || insurerDetail.quotesby == "inhouse") &&
        (bindTypeState == "1" || bindTypeState == "2")
    ) {
        console.log(`Email Bind/Request Initiated (Type ${bindTypeState})`);

        // --- Variable Setup ---
        var insurerEmail = insurerDetail?.emails?.[0]?.email; // Safer access
        if (!insurerEmail) {
           console.error("Insurer email not found!");
           toast.error("Insurer email configuration is missing.");
           return; // Cannot proceed without an email address
        }

        // Add underwriter email if present
        if (insurer.otherinfo?.underwriterInfo?.email) {
            insurerEmail += "," + insurer.otherinfo.underwriterInfo.email;
            console.log("Added underwriter email:", insurer.otherinfo.underwriterInfo.email);
            dispatch(
              updateBindType({
                responseid:insurer._id,
                prospectid,
                bindType: "2",
                underwriterInfo: insurer.otherinfo.underwriterInfo ,
                isBinded: true,
              })
            );
        }

        var businessName = prospectDetails?.CLIENT_BUSINESS_NAME || "[Client Business Name Missing]";
        var brokerName =
            (userInformation?.information?.firstname || "[Broker First Name]") +
            " " +
            (userInformation?.information?.lastname || "[Broker Last Name]");

        // Use user's profile language preference as the authoritative source
        const selectedLanguage = userInformation?.information?.languagepreference || "en";
        console.log('BindModal: Using language preference from user profile:', selectedLanguage);
        const selectedPaymentMethod = bindData.paymentMethod?.value || bindData.paymentMethod || "Agency Bill"; // Handle object or string

        let subject;
        let bodyTemplate;

        // --- Conditional Subject and Body ---
        if (["1", "3"].includes(bindTypeState)) {
          //need to set the correct bind type
          setCurrentBindType('bind1')
            // --- Indication Logic ---
            console.log("Preparing INDICATION email content");
            subject = selectedLanguage === "fr"
                ? `Demande de confirmation d'une indication pour ${businessName}, ${prospectDetails.vertical[selectedLanguage]}, ${prospectDetails.CLIENT_ADDRESS.province}`
                : `Request to Firm Up an Indication for ${businessName}, ${prospectDetails.vertical[selectedLanguage]}, ${prospectDetails.CLIENT_ADDRESS.province}`;
            bodyTemplate = emailBodyBindProspectText[selectedLanguage]; // Use Indication Body Template
            
            dispatch(updateBindTypeCalled({responseid: insurer._id, bindtype: "9" }));
            dispatch(updateProspectStatus({prospectid, statuscode:'under_review'}))
        } else {
          setCurrentBindType('bind1')
            console.log("Preparing BINDABLE email content");
            subject = selectedLanguage === "fr"
                ? `Souscription pour ${businessName}: Devis engageable, ${prospectDetails.vertical[selectedLanguage]}, ${prospectDetails.CLIENT_ADDRESS.province}`
                : `Bind for ${businessName}: Bindable Quote, ${prospectDetails.vertical[selectedLanguage]}, ${prospectDetails.CLIENT_ADDRESS.province}`;
            bodyTemplate = emailBodyBindProspect[selectedLanguage]; 
            
        }

       
        const emailPayload = {
            sendEmailDirectToInsurer: true, 
            downloadingEml: false, 
            mailto: insurerEmail,
            bcc: userInformation.information.user.email,
            body: bodyTemplate
                .replaceAll("<<userName>>", brokerName)
                .replaceAll("<<insuranceBrokerageName>>", userInformation.information.brokerages[0].name)
                .replaceAll("<<clientName>>", prospectDetails.CLIENT_NAME)
                .replaceAll("<<effectiveDate>>", bindData.effectiveDate)
                .replaceAll("<<premiumValue>>", bindData.premium) // Format currency for email body
                .replaceAll("<<insurerFeeValue>>", bindData.insurerFees) // Format currency
                .replaceAll("<<paymentMethod>>", selectedPaymentMethod)
                .replaceAll("<<userEmailAddress>>", userInformation.information.user.email),
            subject: subject
        };

        console.log("Email Payload:", emailPayload);

        setSendEmailDirect(true); 
        setuseEmail(emailPayload);

    
    } else if (insurer.insurercode == "ApprovedCasualtyLegal") {
        console.log("Approved Casualty Legal Bind Initiated");
        setPdfDownloading(PossibleApiStatusValues.loading);

        // Ensure policyStatus is loaded and has data
        if (!policyStatus || !policyStatus.policystatus || policyStatus.policystatus.length === 0) {
            console.error("Policy status data not available!");
            toast.error("Failed to get policy statuses. Please try again.");
            setPdfDownloading(PossibleApiStatusValues.failed);
            return;
        }
        const binderStatusObj = policyStatus.policystatus.find((data) => data.name == "BINDER");
        if (!binderStatusObj) {
            console.error("BINDER status ID not found!");
            toast.error("Failed to find BINDER policy status. Please contact support.");
            setPdfDownloading(PossibleApiStatusValues.failed);
            return;
        }
        const statusId = binderStatusObj._id;

        const startingDateData = dateFormator(bindData.effectiveDate);
        const endingDateData = dateFormator(bindData.expiryDate);

        // Construct the 'otherData' payload carefully from bindData
        const otherDataPayload = {
          insurer: bindData.insurer,
          bindernumber: bindData.bindernumber.toString(),
          premium: parseFloat(bindData.premium) || 0,
          quoteRef: bindData.quoteRef,
          insurerFees: parseFloat(bindData.insurerFees) || 0,
          brokerFees: parseFloat(bindData.brokerFees) || 0,
          taxApplicable: parseFloat(bindData.taxApplicable) || 0,
          brokerComments: bindData.brokerComments,
          comissionRate: parseFloat(bindData.comissionRate) || 0,
          paymentMethod: bindData.paymentMethod?.value || bindData.paymentMethod || "Agency Bill",
          effectiveDate: bindData.effectiveDate, 
          expiryDate: bindData.expiryDate,
        };

        const bodyForInvoice = {
            prospectid: prospectid,
            startDate: startingDateData, 
            expiryDate: endingDateData,   
            statusid: statusId,
            usersid: userInformation.information._id,
            otherData: otherDataPayload, 
            totalPremium: totalPremium, 
            textPayableValue: textPayableValue, 
            commissionEarnedValue: commissionEarnedValue, 
            brokerEmail: userInformation.information.user.email,
        };

        generateInvoicePdf(
            bindData.premium,
            prospectDetails.CLIENT_BUSINESS_NAME,
            bindData.effectiveDate,
            bindData.expiryDate,
            prospectDetails,
            insurerId,
            bodyForInvoice, // Pass the prepared body
            parseFloat(bindData.insurerFees) || 0,
            userInformation.information
        )
        .then(() => {
            console.log("Invoice PDF generated successfully for Approved Casualty Legal");
            dispatch(udpatepolicyJustBinded({ value: true })); 
            setEmailModalOpen(true);
            setPdfDownloading(PossibleApiStatusValues.success);
        })
        .catch((error) => {
           console.error("Error generating Approved Casualty Legal Invoice PDF:", error);
           toast.error("Failed to generate the binder invoice PDF.");
           setPdfDownloading(PossibleApiStatusValues.failed);
         
        });

    // --- Fallback / Error Case ---
    } else {
        console.error("Bind button click fell into unexpected 'else' block.");
        console.error("bindTypeState:", bindTypeState);
        console.error("insurerDetail.quotesby:", insurerDetail.quotesby);
        console.error("insurer.insurercode:", insurer.insurercode);
        // toast.error("An unexpected error occurred during the bind process. Please check the console.");
    }
};



  return (
    <>
      <div
        className="text-center py-3"
        style={{
          backgroundColor: theme.COLORS.secondary_skyblue,
        }}
      >
        <span>
          <h3 className="d-inline">{description.mainHeader}</h3>
        </span>
        <span
          className="rounded-circle float-right mr-4 bg-dark px-2 py-0"
          onClick={() => props.handleBindModalClose()}
          role="button"
        >
          <h5>x</h5>
        </span>
      </div>
      <Row style={{ padding: "19px", width: "100%" }}>
        <Col md={6}>
          <h3>{description.header}</h3>
          <p>{description.paragraph1}</p>
          <p>{description.paragraph2}</p>
          <p>{translations[languagepreference]?.common.hereIsTheProcess}</p>
          <ul style={styles.list}>
            {description.items.map((item, index) => (
              <li key={index} style={styles.listItem}>
                <div style={styles.listItemNumber}>{item.number}</div>
                <div>{item.text}</div>
              </li>
            ))}
          </ul>
          <p>{description.subText1}</p>
          <p>{description.subText2}</p>
        </Col>
        <Col
          md={6}
          style={{
            width: "100%",
          }}
        >
          <form
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
            // className=" g-3 d-flex flex-wrap"
            // style={{ flexDirection: "row", padding: "5px" }}
            // onSubmit={onBindRequestHandler}
          >
            <Col md={6} style={{ width: "100%" }}>
              <Row style={{ width: "100%" }}>
                {/* General Bind Information Header */}
                <Row>
                  <Col
                    md={12}
                    style={{
                      width: "100%",
                      color: theme.COLORS.secondary_skyblue,
                      textAlign: "start",
                    }}
                  >
                    <h6>
                      {
                        translations[languagepreference]?.form
                          .generalBindInformation
                      }
                    </h6>
                  </Col>
                </Row>

                {/* Insurer Label and Input */}
                <Row>
                  <Col md={8}>
                    <label>
                      {translations[languagepreference]?.form.insurerLabel}
                    </label>
                  </Col>

                  <Col md={4}>
                    <input
                      type="text"
                      name="Insurer"
                      style={inputStyle}
                      value={bindData.insurer}
                      readOnly={true}
                    />
                  </Col>
                </Row>

                {/* Bind Number Label and Input */}
                <Row>
                  <Col md={8}>
                    <label>
                      {translations[languagepreference]?.form.bindNumberLabel}
                    </label>
                  </Col>
                  <Col md={4}>
                    <div>
                      <input
                        type="text"
                        name="Bind Number"
                        style={inputStyle}
                        value={bindData.bindernumber}
                        onChange={(e) => {
                          setBindData({
                            ...bindData,
                            bindernumber: e.target.value,
                          });
                        }}
                        readOnly={false}
                      />
                    </div>
                  </Col>
                </Row>

                {/* Conditional Rendering for Quote Reference */}
                {["manual", "external"].includes(insurerDetail.quotesby) && (
                  <>
                    <Row>
                      <Col md={8}>
                        <label>
                          {
                            translations[languagepreference]?.form
                              .quoteReferenceLabel
                          }
                        </label>
                      </Col>
                      <Col md={4}>
                        <input
                          type="text"
                          name="Quote Reference"
                          style={inputStyle}
                          value={bindData?.quoteRef || quoteReference}
                          onChange={(e) =>
                            setBindData({
                              ...bindData,
                              quoteRef: e.target.value,
                            })
                          }
                          readOnly={readOnly}
                          required
                        />
                      </Col>
                    </Row>
                  </>
                )}

                {/* Effective Date Label and Input */}
                <Row>
                  <Col md={8}>
                    <label>
                      {
                        translations[languagepreference]?.form
                          .effectiveDateLabel
                      }
                    </label>
                  </Col>
                  <Col md={4}>
                    <input
                      min={moment().format("YYYY-MM-DD")}
                      max={maxDateFormatted}
                      type="date"
                      name="Effective Date"
                      style={inputStyle}
                      value={bindData.effectiveDate}
                      readOnly={false}
                      onChange={(e) => {
                        setBindData({
                          ...bindData,
                          effectiveDate: e.target.value,
                          expiryDate: moment(e.target.value)
                            .add(1, "years")
                            .format("YYYY-MM-DD"),
                        });
                      }}
                      required
                    />
                  </Col>
                </Row>

                {/* Expiry Date Label and Input */}
                <Row>
                  <Col md={8}>
                    <label>
                      {translations[languagepreference]?.form.expiryDateLabel}
                    </label>
                  </Col>
                  <Col md={4}>
                    <input
                      type="date"
                      name="Expiry Date"
                      style={inputStyle}
                      value={bindData.expiryDate}
                      readOnly={readOnly}
                      onChange={(e) =>
                        setBindData({ ...bindData, expiryDate: e.target.value })
                      }
                      required
                    />
                  </Col>
                </Row>

                {/* Payment Method Label and Select */}
                <Row>
                  <Col md={8}>
                    <label>
                      {
                        translations[languagepreference]?.form
                          .paymentMethodLabel
                      }
                    </label>
                  </Col>
                  <Col md={4}>
                    <Select
                      options={_PaymentMethodList}
                      getOptionLabel={(option) =>
                        option.label[languagepreference]
                      }
                      placeholder={
                        translations[languagepreference]?.form
                          .selectPaymentMethodPlaceholder
                      }
                      value={PaymentMethodList.find(
                        (s) => s.value == bindData.paymentMethod
                      )}
                      styles={customStyles}
                      onChange={(e) => {
                        setBindData({ ...bindData, paymentMethod: e });
                      }}
                    />
                  </Col>
                </Row>
              </Row>

              {/* Financials Section */}
              <Row style={{ width: "100%" }}>
                {/* Financials Header */}
                <Row>
                  <Col
                    md={12}
                    style={{
                      width: "100%",
                      color: theme.COLORS.secondary_skyblue,
                      textAlign: "start",
                    }}
                  >
                    <h6>{translations[languagepreference]?.form.financials}</h6>
                  </Col>

                  {/* Premium Label and Input */}
                  <Col md={8}>
                    <label>
                      {translations[languagepreference]?.form.premiumLabel}
                    </label>
                  </Col>
                  <Col md={4}>
                    {/* <span style={dollerSpan}>$</span> */}
                    <input
                      type="text"
                      name="Premium"
                      style={inputStyle}
                      value={
                        bindData.premium && formatCurrency(bindData.premium)
                      }
                      onChange={(e) => {
                        const regExp = /^\d*\.?\d*$/;
                        if (
                          e.target.value === "" ||
                          regExp.test(e.target.value)
                        ) {
                          setBindData({
                            ...bindData,
                            premium: e.target.value,
                          });
                        }
                      }}
                      required
                      readOnly={readOnly || bindData.price > 0 ? true : false}
                    />
                  </Col>
                </Row>

                {/* Insurer Fees Label and Input */}
                <Row>
                  <Col md={8}>
                    <label>
                      {translations[languagepreference]?.form.insurerFeesLabel}
                    </label>
                  </Col>
                  <Col md={4}>
                    {/* <span style={dollerSpan}>$</span> */}
                    {/* <input
              type="text"
              name="Insurer Fees"
              style={inputStyle}
              value={formatCurrency(bindData.insurerFees)}
              onChange={(e) => {
                
                const regExp = /^\d*\.?\d*$/;
                if (
                  e.target.value == "" ||
                  regExp.test(e.target.value)
                ) {
                  setBindData({
                    ...bindData,
                    insurerFees: e.target.value,
                  });
                }
              }}
              required
            /> */}
                    <NumericFormat
                      style={inputStyle}
                      value={bindData.insurerFees}
                      onValueChange={(values) => {
                        const { value } = values;
                        setBindData({
                          ...bindData,
                          insurerFees: value,
                        });
                      }}
                      readOnly={readOnly}
                      name="Insurer Fees"
                      thousandSeparator={true}
                      prefix={"$"}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      allowNegative={false}
                      required
                    />
                  </Col>
                </Row>

                {/* Broker Fees Label and Input */}
                <Row>
                  <Col md={8}>
                    <label>
                      {translations[languagepreference]?.form.brokerFeesLabel}
                    </label>
                  </Col>
                  <Col md={4}>
                    {/* <span style={dollerSpan}>$</span> */}
                    <NumericFormat
                      style={inputStyle}
                      value={bindData.brokerFees}
                      onValueChange={(values) => {
                        const { value } = values;
                        setBindData({
                          ...bindData,
                          brokerFees: value,
                        });
                      }}
                      name="Broker Fees"
                      thousandSeparator={true}
                      prefix={"$"}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      allowNegative={false}
                      readOnly={readOnly}
                      required
                    />
                  </Col>
                </Row>

                {/* Premium & Fees Label and Input */}
                <Row>
                  <Col md={8}>
                    <label>
                      {
                        translations[languagepreference]?.form
                          .premiumAndFeesLabel
                      }
                    </label>
                  </Col>
                  <Col md={4}>
                    {/* <span style={dollerSpan}>$</span> */}
                    <input
                      type="text"
                      name="Total Premium & Fees"
                      style={inputStyle}
                      value={formatCurrency(totalPremium)}
                      readOnly={true}
                    />
                  </Col>
                </Row>

                {/* Tax Rate Applicable Label and Input */}
                <Row>
                  <Col md={8}>
                    <label>
                      {
                        translations[languagepreference]?.form
                          .taxRateApplicableLabel
                      }
                    </label>
                  </Col>
                  <Col md={4}>
                    <input
                      type="text"
                      min="0"
                      name="Tax rate applicable"
                      style={inputStyle}
                      value={bindData && bindData.taxApplicable}
                      onChange={(e) => {
                        const regExp = /^\d*\.?\d*$/;

                        if (
                          e.target.value === "" ||
                          regExp.test(e.target.value)
                        ) {
                          setBindData({
                            ...bindData,
                            taxApplicable: e.target.value,
                          });
                        }
                      }}
                    />
                  </Col>
                </Row>

                {/* Taxes Payable Label and Input */}
                <Row>
                  <Col md={8}>
                    <label>
                      {translations[languagepreference]?.form.taxesPayableLabel}
                    </label>
                  </Col>
                  <Col md={4}>
                    {/* <span style={dollerSpan}>$</span> */}
                    <input
                      type="text"
                      min="0"
                      name="Taxes payable"
                      style={inputStyle}
                      value={
                        textPayableValue &&
                        formatCurrency(textPayableValue.toFixed(2))
                      }
                      readOnly={true}
                    />
                  </Col>
                </Row>

                {/* Commission Rate Label and Input */}
                <Row>
                  <Col md={8}>
                    <label>
                      {
                        translations[languagepreference]?.form
                          .commissionRateLabel
                      }
                    </label>
                  </Col>
                  <Col md={4}>
                    <input
                      type="text"
                      min="0"
                      name="Commission rate"
                      readOnly={readOnly}
                      style={inputStyle}
                      value={bindData.comissionRate && bindData.comissionRate}
                      onChange={(e) => {
                        const regExp = /^\d*\.?\d*$/;
                        if (
                          e.target.value === "" ||
                          regExp.test(e.target.value)
                        ) {
                          setBindData({
                            ...bindData,
                            comissionRate: e.target.value,
                          });
                        }
                      }}
                    />
                  </Col>
                </Row>

                {/* Commission Earned Label and Input */}
                <Row>
                  <Col>
                    <label style={{ width: "100%" }}>
                      {
                        translations[languagepreference]?.form
                          .commissionEarnedLabel
                      }
                    </label>
                  </Col>
                  <Col md={4}>
                    {/* <span style={{ ...dollerSpan, bottom: "50%" }}>$</span> */}
                    <input
                      type="text"
                      name="Commission earned"
                      style={inputStyle}
                      value={
                        commissionEarnedValue &&
                        formatCurrency(commissionEarnedValue.toFixed(2))
                      }
                      readOnly={readOnly}
                    />
                  </Col>
                </Row>
              </Row>
            </Col>
          </form>
          <Row>
            <Col
              md={12}
              style={{
                width: "100%",
                display: "flex",

                justifyContent: "end",
                alignContent: "end",
              }}
            >
              {!notDropDownButton && (
                <DropdownButton
                  style={{
                    paddingTop: "10px",
                    width: "77%",
                    // display: "flex",
                  }}
                  className="bindModal"
                  disabled={
                    false ||
                    pdfDownloading == PossibleApiStatusValues.loading ||
                    pdfDownloading == PossibleApiStatusValues.success ||
                    pdfDownloading == PossibleApiStatusValues.failed
                      ? true
                      : false
                  }
                  open={false}
                  // onSelect={onBindRequestHandler}
                  variant="warning"
                  title={description.button}
                >
                  {insurer.insurercode !== "ApprovedCasualtyLegal" && (
                    <Dropdown.Item
                      style={{
                        width: "100%",
                      }}
                      eventKey="1"
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                    >
                      Edit PDF Settings
                    </Dropdown.Item>
                  )}
                  {insurer.insurercode !== "ApprovedCasualtyLegal" && (
                    <Dropdown.Item
                      style={{
                        width: "100%",
                      }}
                      eventKey="1"
                      onClick={() => {
                        setuseEmail(false);
                      }}
                    >
                      Download a PDF
                    </Dropdown.Item>
                  )}
                  {insurer.insurercode !== "ApprovedCasualtyLegal" && (
                    <Dropdown.Item
                      style={{
                        width: "100%",
                      }}
                      eventKey="2"
                      onClick={(e) => {
                        //e.preventDefault();
                        var insurerEmail = insurerDetail?.emails[0].email;
                        var businessName = prospectDetails.CLIENT_BUSINESS_NAME;
                        var brokerName =
                          userInformation?.information?.firstname +
                          " " +
                          userInformation?.information?.lastname;

                      // Use user's profile language preference as the authoritative source
                      const selectedLanguage = userInformation?.information?.languagepreference || "en";
                      console.log('BindModal Dropdown: Using language preference from user profile:', selectedLanguage);
                      setCurrentBindType('bind2')
                     
//regular bind
  const subject = selectedLanguage === "fr"
  ? "Souscription pour " + businessName + ": Devis engageable, " + prospectDetails.vertical[selectedLanguage] + ", " + prospectDetails.CLIENT_ADDRESS.province
  : "Bind for " + businessName + ":Bindable Quote, " + prospectDetails.vertical[selectedLanguage] + ", " + prospectDetails.CLIENT_ADDRESS.province;
                        //return;
                        setuseEmail({
                          downloadingEml: true,
                          mailto:insurerEmail,
                          bcc: userInformation.information.user.email,
                          body: emailBodyBindProspect[selectedLanguage] 
                            .replaceAll("<<userName>>", brokerName)
                            .replaceAll(
                              "<<insuranceBrokerageName>>",
                              userInformation.information.brokerages[0].name
                            )
                            .replaceAll(
                              "<<clientName>>",
                              prospectDetails.CLIENT_NAME
                            )
                            .replaceAll(
                              "<<effectiveDate>>",
                              bindData.effectiveDate
                            )
                            .replaceAll("<<premiumValue>>", bindData.premium)
                            .replaceAll(
                              "<<insurerFeeValue>>",
                              bindData.insurerFees
                            )
                            .replaceAll(
                              "<<paymentMethod>>",
                              bindData.paymentMethod
                            )
                            .replaceAll(
                              "<<userEmailAddress>>",
                              userInformation.information.user.email
                            ),

                          
                          subject: subject
                        });
                      }}
                    >
                      Download an email including a PDF
                    </Dropdown.Item>
                  )}
                </DropdownButton>
              )}
              {["4", "3"].includes(bindTypeState) && (
                <button
                  style={{
                    backgroundColor: "#ff9966",
                    color: "white",
                    height: "4vh",
                    marginTop: "1.8%",
                  }}
                  onClick={() => {
                    if (covers[855]) {
                      window.location.href = covers[855];
                      return;
                    }
                    const showTOC = localStorage.getItem("showTOC") == "true";
                    const showAnsweredOnly =
                      localStorage.getItem("showAnsweredOnly") == "true";
                    // Use user's profile language preference for PDF generation

                    dispatch(
                      bindExternalResponse({
                        responseid: insurerId,
                        prospectid,
                        include_toc: showTOC,
                        show_empty_answers: showAnsweredOnly,
                        pdf_language_selected: languagepreference || "en",

                        otherinfo: {
                          effectiveDate: bindData.effectiveDate,
                          expiryDate: bindData.expiryDate,
                        },
                      })
                    );
                    props.handleBindModalClose();
                  }}
                >
                  {description.button}
                </button>
              )}

              {
                insurer.insurercode !== "ApprovedCasualtyLegal" &&
                (insurerDetail.quotesby == "external" ||
                  insurerDetail.quotesby == "inhouse") &&
                bindTypeState !== "1" &&
                bindTypeState !== "2" && (
                  <button
                    style={{
                      backgroundColor: "#ffc107",

                      height: "4vh",
                    }}
                    onClick={() => {
                      const showTOC = localStorage.getItem("showTOC") == "true";
                      const showAnsweredOnly =
                        localStorage.getItem("showAnsweredOnly") == "true";
                      // Use user's profile language preference for PDF generation

                      dispatch(
                        bindExternalResponse({
                          responseid: insurerId,
                          prospectid,
                          include_toc: showTOC,
                          show_empty_answers: showAnsweredOnly,
                          pdf_language_selected: languagepreference || "en",
                          otherinfo: {
                            effectiveDate: bindData.effectiveDate,
                            expiryDate: bindData.expiryDate,
                          },
                        })
                      );
                      props.handleBindModalClose();
                    }}
                  >
                    {description.button}
                  </button>
                )}
                
              {insurer.insurercode !== "ApprovedCasualtyLegal" &&
                (insurerDetail.quotesby == "external" ||
                  insurerDetail.quotesby == "inhouse") &&
                (bindTypeState == "1" || bindTypeState == "2") && (
                  <Button
                    style={{
                      backgroundColor: "#ffc107",
                      width: "77%",
                      // height: "4vh",
                      color: "black",
                      paddingTop: "10px",
                    }}

                    onClick={() => {
                      handlBindButton();
                    }}
                  >
                    {description.button}
                  </Button>
                )}

              {insurer.insurercode == "ApprovedCasualtyLegal" && (
                <Button
                  style={{
                    backgroundColor: "#ffc107",
                    width: "77%",
                    // height: "4vh",
                    color: "black",
                    paddingTop: "10px",
                  }}
                  disabled={
                    false ||
                    pdfDownloading === PossibleApiStatusValues.loading ||
                    pdfDownloading === PossibleApiStatusValues.success ||
                    pdfDownloading === PossibleApiStatusValues.failed
                      ? true
                      : false
                  }
                  onClick={() => {
                    handlBindButton();
                  }}
                >
                  {description.button}
                </Button>
              )}

              {pdfDownloading == PossibleApiStatusValues.loading && (
                <Spinner
                  style={{ marginLeft: "10px" }}
                  animation="border"
                  variant="primary"
                />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <PdfSettingsModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      {/* Bind Code: 1
    name: Manual Bind request to insurer - Indication
    Bind Code: 2
    name: "Manual “Bind request” to insurer - Bindable"
    Bind Code: 3
    name: Manual Quote and Bind in insurer portal - Indication
    Bind Code: 4
    name: Manual Quote and Bind in insurer portal - Bindable */}
      <Modal
        show={emailModalOpen}
        onHide={() => {
          setEmailModalOpen(false);
          props.handleBindModalClose();
        }}
        centered={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {insurerDetail.quotesby == "manual"
              ? externalTranslations[languagepreference].emailDownloadedTitle
              : externalTranslations[languagepreference].emailSentToInsurerTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {insurer.insurercode !== "ApprovedCasualtyLegal" &&
            insurerDetail.quotesby !== "manual" && (bindTypeState === "1" || bindTypeState === "9")
               && (
              <p>
                {externalTranslations[languagepreference].emailSentForIndication}
               
              </p>
            )}
          {insurer.insurercode !== "ApprovedCasualtyLegal" &&
            insurerDetail.quotesby !== "manual" &&
            (bindTypeState === "3" ) && (
              <p>
                {externalTranslations[languagepreference].emailSentForConfirmation}
                bindsate:{bindTypeState}
               
              </p>
            )}
          {insurer.insurercode !== "ApprovedCasualtyLegal" &&
            insurerDetail.quotesby !== "manual" &&
            (bindTypeState === "4" || bindTypeState === "2") && (
              <p>
                {externalTranslations[languagepreference].emailSentWithDetails}
               
              </p>
            )}

          {insurerDetail.quotesby === "manual" &&
            insurer.insurercode !== "ApprovedCasualtyLegal" && (
              <p>
                {externalTranslations[languagepreference].manualQuoteEmailInstruction}
               
              </p>
            )}

          {insurer.insurercode === "ApprovedCasualtyLegal" && (
            <p>
              {externalTranslations[languagepreference].approvedCasualtyLegalMessage}
            
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setEmailModalOpen(false);
              props.handleBindModalClose();
              setTimeout(() => {
               console.log("NAVIGATE TO CUSTOMER, ", prospectInformation.customerid)
               if(prospectInformation.customerid){
                 history(`/customer?id=${prospectInformation.customerid}`)
               }
              }, 300);
              if (["2"].includes(bindTypeState)) {
                setTimeout(() => {
                  dispatch(
                    setautoreminder({
                      text: externalTranslations[languagepreference].reminderText,
                      title: externalTranslations[languagepreference].reminderTitle,
                      prospectid,
                      remindercategory: externalTranslations[languagepreference].reminderCategory,
                    })
                  );
                }, 600);
              }
            }}
          >
            {externalTranslations[languagepreference].closeButton}
            
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={failedBindModalOpen}
        onHide={() => {
          setFailedBindModalOpen(false);
          props.handleBindModalClose();
        }}
        centered
        backdrop="static" // Prevents closing by clicking outside
        keyboard={false} // Prevents closing with the Esc key
        className="bind-failed-modal"
      >
        <Modal.Header closeButton className="modal-header-danger">
          <Modal.Title className="text-danger">
          {externalTranslations[languagepreference].bindFailedTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="error-message">
            <p>
              <strong>
              {externalTranslations[languagepreference].bindFailedIssue}
       
              </strong>
            </p>
            <p>
            {externalTranslations[languagepreference].bindFailedRetry}
           
            </p>
            <p>
            {externalTranslations[languagepreference].bindFailedNotCompleted}
            
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              setFailedBindModalOpen(false);
              props.handleBindModalClose();
            }}
          >
            {externalTranslations[languagepreference].closeButton}
            
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BindModal;